import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from 'semantic-ui-react';
import KeyboardInput from 'Common/Components/Keyboard/KeyboardInput';

import 'PointOfSale/styles/components/cepCard.less';

const BulkServe = ({
  onClickServe,
  setPlaceholder,
  placeHolderText,
  bulkServeCount,
  onChangeBulkChange,
  forwardedRef,
}) => {
  return (
    <Grid padded className="text-center">
      <Grid.Row>
        <Grid.Column>
          <KeyboardInput
            layoutType="numeric"
            onFocus={() => setPlaceholder('')}
            onBlur={() => setPlaceholder('0')}
            placeholder={placeHolderText}
            className="bulk-input"
            value={bulkServeCount}
            onChange={onChangeBulkChange}
            ref={forwardedRef}
            min="0"
            maxLength={3}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Button
          fluid
          className="cep-serve-button"
          content="Serve"
          onClick={() => onClickServe(bulkServeCount || 0, true)}
        />
      </Grid.Row>
    </Grid>
  );
};

BulkServe.propTypes = {
  onClickServe: PropTypes.func,
  setPlaceholder: PropTypes.func,
  onChangeBulkChange: PropTypes.func,
  placeHolderText: PropTypes.string,
  bulkServeCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default BulkServe;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/component/BulkServe.js